module.exports = __webpack_public_path__ + "media/images/recrutare/social/Linkedin-53cf58934ac1c51d52486ba611db223c.png";